import { Empresa } from "src/app/auth/models/empresa.model";

export class IUsuarioEmpresa {
  documentoIdentificador: string;
  nome: string;
  email: string;
  empresas: Empresa[] = [];
}
